function RoadMap() {
  return (
    <div className="flex flex-row w-full items-center justify-center ">
      <div className=" hidden lg:flex">
        {" "}
        <div className="flex flex-col items-center justify-center">
          <div className="h-[80px] w-[80px] border-[3px] border-[#FBDF8B] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px]">2010</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#FBDF8B]"></div>
          <div className="h-[20px] w-[170px] bg-[#FBDF8B] rounded-l-[10px]"></div>
          <div className="h-[30px] w-[30px] bg-[#FBDF8B] border-t-[15px] border-t-[#FBDF8B] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start ">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
              Founded I&I, <br /> COACHING STUDENTS
            </div>
            <p className="w-[50px] h-[2px] bg-[#FBDF8B] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center rotate-180 mt-[-70px]">
          <div className="h-[80px] w-[80px] border-[3px] border-[#FFC914] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px] rotate-180">2011</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#FFC914]"></div>
          <div className="h-[20px] w-[170px] bg-[#FFC914] "></div>
          <div className="h-[30px] w-[30px] bg-[#FFC914] border-t-[15px] border-t-[#FFC914] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start rotate-180">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
            Women enterprise & Business Models
            </div>
            <p className="w-[50px] h-[2px] bg-[#FFC914] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="h-[80px] w-[80px] border-[3px] border-[#EB6D74] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px]">2014</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#EB6D74]"></div>
          <div className="h-[20px] w-[170px] bg-[#EB6D74] "></div>
          <div className="h-[30px] w-[30px] bg-[#EB6D74] border-t-[15px] border-t-[#EB6D74] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start ">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
            AGILE METHODOLOGY
            </div>
            <p className="w-[50px] h-[2px] bg-[#EB6D74] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
         <div className="flex flex-col items-center justify-center rotate-180 mt-[-70px]">
          <div className="h-[80px] w-[80px] border-[3px] border-[#DB162F] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px] rotate-180">2017</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#DB162F]"></div>
          <div className="h-[20px] w-[170px] bg-[#DB162F] "></div>
          <div className="h-[30px] w-[30px] bg-[#DB162F] border-t-[15px] border-t-[#DB162F] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start rotate-180">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
            HACKATHONS, SCRUMS & COACHING
            </div>
            <p className="w-[50px] h-[2px] bg-[#DB162F] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="h-[80px] w-[80px] border-[3px] border-[#4395C1] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px]">2019</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#4395C1]"></div>
          <div className="h-[20px] w-[170px] bg-[#4395C1] "></div>
          <div className="h-[30px] w-[30px] bg-[#4395C1] border-t-[15px] border-t-[#4395C1] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start ">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
            AGILE METHODOLOGY
            </div>
            <p className="w-[50px] h-[2px] bg-[#4395C1] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center rotate-180 mt-[-70px]">
          <div className="h-[80px] w-[80px] border-[3px] border-[#33658A] rounded-full flex items-center justify-center">
            <p className="font-[700] font-raleway text-[18px] rotate-180">2022</p>
          </div>
          <div className="h-[80px] w-[5px] bg-[#33658A]"></div>
          <div className="h-[20px] w-[170px] bg-[#33658A] rounded-l-[10px]"></div>
          <div className="h-[30px] w-[30px] bg-[#33658A] border-t-[15px] border-t-[#33658A] border-l-white border-l-[15px] border-r-[15px] border-r-white"></div>
          <div className="h-[150px] w-[150px]  mt-[15px] flex flex-col items-center justify-start rotate-90 lg:rotate-180">
            <div className="text-[12px] font-[400] font-montserrat text-center uppercase">
            ACCESSIBLE internationally
            </div>
            <p className="w-[50px] h-[2px] bg-[#33658A] my-[20px]"></p>
            <div className="break-all font-lato font-[400] text-[12px] text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{" "}
            </div>
          </div>
        </div>
      </div>
      <div className='flex flex-col lg:hidden justify-start px-[2px]'>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#FBDF8B] font-raleway font-[700] text-[12px] flex items-center justify-center">2010</div>
            <div className="w-[20px] h-[2px] bg-[#FBDF8B]"></div>
            <div className="h-[130px] w-[8px] bg-[#FBDF8B] rounded-t-[10px]"></div>
            <div className="w-[220px]   ml-[10px] flex flex-col p-[4px]">
            <p className=" font-[400] uppercase font-montserrat text-[12px] ">Founded I&I, COACHING STUDENTS</p>
                <p className='bg-[#FBDF8B] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">I&I started out by focusing on helping students develop their employability and entrepreneurship skills.</p>
            </div>

        </div>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#FFC914] font-raleway font-[700] text-[12px] flex items-center justify-center">2011</div>
            <div className="w-[20px] h-[2px] bg-[#FFC914]"></div>
            <div className="h-[130px] w-[8px] bg-[#FFC914] "></div>
            <div className="w-[220px]  ml-[10px] p-[4px] flex flex-col ">
            <p className="uppercase font-[400] font-montserrat text-[12px] ">Women enterprise & Business Models</p>
                <p className='bg-[#F4B33E] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">We further expanded our offerings to female founders, helping them build professional profiles and develop their companies.</p>
            </div>

        </div>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#EB6D74] font-raleway font-[700] text-[12px] flex items-center justify-center">2014</div>
            <div className="w-[20px] h-[2px] bg-[#EB6D74]"></div>
            <div className="h-[130px] w-[8px] bg-[#EB6D74] "></div>
            <div className="w-[220px]   ml-[10px] flex flex-col p-[4px]">
            <p className=" font-[400] uppercase font-montserrat text-[12px] ">TEcH STARTUPS & AGILE</p>
                <p className='bg-[#EB6D74] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">Our CEO was headhunted to go to Brazil to build startup acceleration programs, which was also where I&I started implementing startup knowledge in education.</p>
            </div>

        </div>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#DB162F] font-raleway font-[700] text-[12px] flex items-center justify-center">2017</div>
            <div className="w-[20px] h-[2px] bg-[#DB162F]"></div>
            <div className="h-[130px] w-[8px] bg-[#DB162F] "></div>
            <div className="w-[220px]   ml-[10px] flex flex-col ">
            <p className=" font-[400] uppercase font-montserrat text-[12px] ">SCRUM EDUCATIONAL EXPERIENCE (SEE)</p>
                <p className='bg-[#DB162F] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">Based on our experience working with schools and universities, we invested in developing SEE which spun off as an independent identity in 2019</p>
            </div>

        </div>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#4395C1] font-raleway font-[700] text-[12px] flex items-center justify-center">2019</div>
            <div className="w-[20px] h-[2px] bg-[#4395C1]"></div>
            <div className="h-[130px] w-[8px] bg-[#4395C1] "></div>
            <div className="w-[220px]   ml-[10px] flex flex-col">
            <p className=" font-[400] uppercase font-montserrat text-[12px] ">Corporate innovation</p>
                <p className='bg-[#4395C1] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">We refined our focus to work with career switchers, entrepreneurs and used SEE models to support corporate innovation.</p>
            </div>

        </div>
        <div className="flex items-center">
            <div className="h-[60px] w-[60px] rounded-full border-[2px] border-[#33658A] font-raleway font-[700] text-[12px] flex items-center justify-center">2022</div>
            <div className="w-[20px] h-[2px] bg-[#33658A]"></div>
            <div className="h-[130px] w-[8px] bg-[#33658A] rounded-b-[10px]"></div>
            <div className="w-[220px]   ml-[10px] flex flex-col">
            <p className=" font-[400] uppercase font-montserrat text-[12px] ">ACCESSIBLE internationally</p>
                <p className='bg-[#33658A] h-[2px] w-[40px] m-[1px]'></p>
                <p className="font-[400] font-lato text-[12px] break-all ">Due to high demand and the post-pandemic requirements of the market, we enhanced our offerings to support individuals on their personal and professional development journey through coaching tools, as well as live and online courses.</p>
            </div>

        </div>
      </div>
    </div>
  );
}

export default RoadMap;
